var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "id": "table",
      "responsive": "",
      "small": "",
      "items": _vm.getCurrentEventFlowItems,
      "fields": _vm.getFields
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(_vm._s(data.label))])];
      }
    }, {
      key: "head(details)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "pointer nowrap",
          on: {
            "click": _vm.toggleAll
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.show-all-details')) + " "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.toggled,
            expression: "!toggled"
          }],
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_down.svg")
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.toggled,
            expression: "toggled"
          }],
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_up.svg")
          }
        })])];
      },
      proxy: true
    }, {
      key: "cell(brief)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "nowrap brief"
        }, [_vm._v(" " + _vm._s(row.item.brief) + " ")])];
      }
    }, {
      key: "cell(startedAt)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.formatToTime(row.item.startedAt)) + " ")])];
      }
    }, {
      key: "cell(endedAt)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.formatToTime(row.item.endedAt)) + " ")])];
      }
    }, {
      key: "cell(totalTime)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.differenceInTime(row.item.endedAt, row.item.startedAt)) + " ")])];
      }
    }, {
      key: "cell(locationName)",
      fn: function fn(row) {
        var _row$item$location;

        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s((_row$item$location = row.item.location) === null || _row$item$location === void 0 ? void 0 : _row$item$location.name) + " ")])];
      }
    }, {
      key: "cell(topic)",
      fn: function fn(row) {
        var _row$item$topic;

        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s((_row$item$topic = row.item.topic) === null || _row$item$topic === void 0 ? void 0 : _row$item$topic.name) + " ")])];
      }
    }, {
      key: "cell(responsible)",
      fn: function fn(row) {
        var _row$item$responsible, _row$item$responsible2;

        return [_c('span', {
          staticClass: "nowrap"
        }, [_c('div', {
          staticClass: "responsible-wrapper"
        }, [_c('div', {
          staticClass: "little-circle",
          style: "background-color:".concat((_row$item$responsible = row.item.responsible) === null || _row$item$responsible === void 0 ? void 0 : _row$item$responsible.color)
        }), _vm._v(" " + _vm._s((_row$item$responsible2 = row.item.responsible) === null || _row$item$responsible2 === void 0 ? void 0 : _row$item$responsible2.name) + " ")])])];
      }
    }, {
      key: "cell(details)",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "details"
        }, [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !row.detailsShowing,
            expression: "!row.detailsShowing"
          }],
          staticClass: "pointer",
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_down.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: row.detailsShowing,
            expression: "row.detailsShowing"
          }],
          staticClass: "pointer",
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_up.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        })])];
      }
    }, {
      key: "row-details",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "text text-justify"
        }, [_vm._v(" " + _vm._s(row.item.description) + " ")])];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }